import ConfigFile from "../../../datasets/config_file";

export const computeCashMoodPoints = (eventType, beforeCash, cashChg, beforeMoodPoints, moodPointChg, subProcess ) => {
   
   let afterCash = (+beforeCash + +cashChg).toFixed(2);
   afterCash = afterCash.toString();
   let afterMoodPoints = 0;
   if (eventType === "RegularCard"){
      const fullMoodPointChg = (+moodPointChg * +ConfigFile.gameBoard.moodPointMultiplier).toFixed(0);
      afterMoodPoints = (+beforeMoodPoints + +fullMoodPointChg).toString();
   }else{
      afterMoodPoints = +beforeMoodPoints + +moodPointChg;
   }

   const returnObj = {cash: afterCash, moodPoints: afterMoodPoints, subProcess: subProcess};
   return returnObj;
   
}
export default computeCashMoodPoints;
